const DataViewToolbar = ({
  titleSection,
  actionButtons,
  searchBar,
  inlineSearchBar,
  filterButtons,
  pagination,
}: {
  titleSection: React.ReactNode;
  actionButtons?: React.ReactNode;
  searchBar?: React.ReactNode;
  inlineSearchBar?: React.ReactNode;
  filterButtons?: React.ReactNode;
  pagination: React.ReactNode;
}) => {
  return (
    <div className="flex-shrink-0">
      {/* Main Toolbar */}
      <div className="border-b border-dashed py-2">
        <div className="h-full">
          <div className="flex h-full min-w-max justify-between">
            <div className="flex items-center gap-2">
              {/* Title Section */}
              <div className={`mr-4 border-gray-600`}>{titleSection}</div>

              {/* Action Buttons */}
              {actionButtons ? (
                <div className="flex w-fit items-center justify-between gap-3">{actionButtons}</div>
              ) : null}
            </div>

            <div className="flex flex-1 items-center justify-end gap-2">
              {/* Inline Search Bar */}
              {inlineSearchBar ? <div className="flex items-center">{inlineSearchBar}</div> : null}

              {/* Filters */}
              {filterButtons ? <div className="flex items-center gap-2">{filterButtons}</div> : null}

              {/* Pagination */}
              <div className="mx-1">{pagination}</div>
            </div>
          </div>
        </div>
      </div>

      {searchBar && (
        <div className="border-b border-dashed py-2">
          <div className="w-full">{searchBar}</div>
        </div>
      )}
    </div>
  );
};

export default DataViewToolbar;
